/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ListWithdrawnOrderQuery { 
    index?: number;
    size?: number;
    orderBy?: string | null;
    direction?: string | null;
    azureAdUpn: string;
    startDate?: string | null;
    endDate?: string | null;
}

